import React from 'react';
import { Download, FileText, Smartphone, Tablet, Monitor } from 'lucide-react';
import { Button } from '../ui/Button';
export function Deliverables() {
  return <section className="py-20 bg-white border-t border-gray-100" data-id="element-115">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-116">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-117">
          Esto es lo que recibes hoy
        </h2>

        <div className="bg-[#F5F2EA] rounded-3xl p-8 md:p-12 mb-10 relative overflow-hidden" data-id="element-118">
          {/* Decorative elements */}
          <div className="absolute top-0 left-0 w-32 h-32 bg-[#4A6741]/10 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-119"></div>
          <div className="absolute bottom-0 right-0 w-40 h-40 bg-[#C06C54]/10 rounded-full translate-x-1/3 translate-y-1/3" data-id="element-120"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-121">
            <div className="w-full md:w-1/3" data-id="element-122">
              <img src="https://cdn.magicpatterns.com/uploads/34JWmqSSYCqR66UCzDvY7p/mockup1.png" alt="eBook Cover" className="w-full h-auto rounded-lg shadow-xl rotate-[-2deg] hover:rotate-0 transition-transform duration-300" data-id="element-123" />
            </div>

            <div className="w-full md:w-2/3 text-left" data-id="element-124">
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-125">
                eBook: Cosmética Natural y Artesanal en Casa
              </h3>
              <p className="text-[#C06C54] font-bold text-lg mb-6" data-id="element-126">
                Edición Completa Digital (PDF)
              </p>

              <div className="space-y-4 mb-8" data-id="element-127">
                <div className="flex items-center gap-3" data-id="element-128">
                  <div className="bg-white p-2 rounded-lg shadow-sm" data-id="element-129">
                    <Download className="w-5 h-5 text-[#4A6741]" data-id="element-130" />
                  </div>
                  <div data-id="element-131">
                    <p className="font-bold text-gray-800" data-id="element-132">
                      Descarga Inmediata
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-133">
                      Acceso automático a tu correo tras la compra.
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-3" data-id="element-134">
                  <div className="bg-white p-2 rounded-lg shadow-sm" data-id="element-135">
                    <Monitor className="w-5 h-5 text-[#4A6741]" data-id="element-136" />
                  </div>
                  <div data-id="element-137">
                    <p className="font-bold text-gray-800" data-id="element-138">Multidispositivo</p>
                    <p className="text-sm text-gray-600" data-id="element-139">
                      Léelo en tu celular, tablet o computadora.
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-3" data-id="element-140">
                  <div className="bg-white p-2 rounded-lg shadow-sm" data-id="element-141">
                    <FileText className="w-5 h-5 text-[#4A6741]" data-id="element-142" />
                  </div>
                  <div data-id="element-143">
                    <p className="font-bold text-gray-800" data-id="element-144">
                      Material Imprimible
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-145">
                      Incluye plantillas y fichas listas para imprimir.
                    </p>
                  </div>
                </div>
              </div>

              <Button variant="primary" size="lg" fullWidth withMicrocopy data-id="element-146">
                DESCARGAR AHORA POR $6,36 USD
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}